import { ERROR_ALERT_TEXT } from '../constants';

const isSsr = typeof window === 'undefined';

export function setupAnalytics() {
  if (!isSsr && window.LIFE_CYCLE_EVENT_BUS) {
    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('communicationPreferences.page-load');
  }
}

export function addAnalyticEvent(event) {
  if (!isSsr) {
    let dd = window.digitalData;
    if (dd) {
      if (!dd.event) {
        dd.event = [];
      }
      dd.event.push(event);
    }
  }
}

export function analyticEvent(settings) {
  return {
    category: {
      primaryCategory: 'button submission'
    },
    eventInfo: {
      eventName: 'my account settings',
    },
    myAccount: {
      settings
    }
  };
}

export function overlayEvent(name) {
  return {
    category: {
      primaryCategory: 'overlay'
    },
    eventInfo: {
      eventName: name,
    }
  };
}

function errorEvent(displayType, pageSection) {
  return {
    category: {
      primaryCategory: 'error'
    },
    eventInfo: {
      eventName: 'post page error',
      error: [
        {
          type: 'system',
          displayType,
          pageSection: pageSection || 'my account settings',
          message: ERROR_ALERT_TEXT,
          code: 'n/a',
        }
      ]
    }
  };
}

export function inlineErrorEvent(pageSection) {
  return errorEvent('inline', pageSection);
}

export function onLoadErrorEvent(pageSection) {
  return errorEvent('page', pageSection);
}
